import { QuestionsList } from './QuestionsList';

export default QuestionsList;